import { Box, Stack, Text } from '@chakra-ui/react'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import type { Offer } from 'BrokerTsLib/src/dtos'
import React, { useMemo } from 'react'
import { CustomConfirmDialog } from '../CustomConfirmDialog'

interface BmwContinueMessageDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (ignoreCallback: boolean) => void
  selectedOffers: Offer[]
}

export const BmwContinueMessageDialog: React.FC<BmwContinueMessageDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedOffers
}) => {
  const { translate, translateFormat } = useTranslationsContext()

  const handleConfirm = () => {
    onConfirm(false)
    onClose()
  }

  const { isMultipleOffers, isMultipleInsurers } = useMemo(() => {
    const offerCount = selectedOffers.length
    const uniqueInsurers = new Set(selectedOffers.map((o) => o.insurerId)).size

    return {
      isMultipleOffers: offerCount > 1,
      isMultipleInsurers: uniqueInsurers > 1,
    }
  }, [selectedOffers])

  // Překlad jednotlivých fragmentů
  const translationParams = {
    vybranouKalkulaci: isMultipleOffers
      ? translate('bmwContinueMessageDialog.plural.offers', 'vybrané kalkulace').toLocaleLowerCase()
      : translate('bmwContinueMessageDialog.singular.offer', 'vybranou kalkulaci').toLocaleLowerCase(),
    pojistovny: isMultipleInsurers
      ? translate('bmwContinueMessageDialog.plural.insurers', 'pojišťoven').toLocaleLowerCase()
      : translate('bmwContinueMessageDialog.singular.insurer', 'pojišťovny').toLocaleLowerCase(),
  }

  // Sestavení výchozího textu (fallbacku)
  const defaultText = `Kliknutím na 'Rozumím' uložíte ${translationParams.vybranouKalkulaci} u ${translationParams.pojistovny}. 
    Po přesměrování do systému BMW FS (web.lsp) je nutné nabídku financování s pojištěním uložit, 
    jinak nepůjde pojištění aktivovat.`

  return (
    <CustomConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      title={translate('warning', 'Upozornění')}
      yesButton={{
        text: translate('understand', 'Rozumím'),
        onClick: handleConfirm,
      }}
      noButton={{
        customElement: <Box />,
        onClick: onClose,
      }}
    >
      <Stack>
        <Text>
          {translateFormat(
            'bmwContinueMessageDialog.text._vybranouKalkulaci_pojistovny',
            defaultText,
            translationParams
          )}
        </Text>
      </Stack>
    </CustomConfirmDialog>
  )
}